import * as yup from 'yup';
import { IBuyer } from '../Buyer/Buyer';
import { IMatch } from '../Match/Match';
import { IInvitationCode } from 'domain/entities/InvitationCode/InvitationCode';

export const BUYER_USER_ROLE = {
    USER: 10,
    SUPER_USER: 20,
    ADMIN_USER: 30,
    SUPPORT_USER: 40,
} as const;

export type BuyerUserRole = (typeof BUYER_USER_ROLE)[keyof typeof BUYER_USER_ROLE];

export const BUYER_USER_ROLE_LABEL = {
    10: 'ユーザー',
    20: '管理者',
    30: 'システム管理者',
} as const;

export const USER_ROLE_LABEL_FOR_EDIT = {
    10: 'ユーザー',
    20: '管理者',
} as const;

export const GENDER = {
    1: '男性',
    2: '女性',
    0: 'それ以外',
} as const;

export const USER_ROLE_LABEL = {
    10: 'ユーザー',
    20: '管理者',
    30: 'システム管理者',
    40: 'サポート',
} as const;

export const PROFILE_STAGE = {
    ONLY_PASSWORD: 1,
    NEED_COMPANY_INFO: 2,
    NEED_USER_PROFILE: 3,
    COMPLETE: 4,
} as const;
export type ProfileStage = (typeof PROFILE_STAGE)[keyof typeof PROFILE_STAGE];

export const COMPANY_LISTING_STATUS = {
    BEFORE_RECRUITMENT: 0,
    RECRUITING: 1,
    RECRUITMENT_EXPIRED: 2,
} as const;

export type BuyerListingStatus = (typeof COMPANY_LISTING_STATUS)[keyof typeof COMPANY_LISTING_STATUS];

export interface IBuyerUser {
    id: number;
    buyer: IBuyer | null;
    last_name: string;
    first_name: string;
    last_name_kana: string | null;
    first_name_kana: string | null;
    email: string;
    birthday: string | null;
    gender: number;
    icon_image: string | null;
    status: number;
    role: BuyerUserRole;
    department: string | null;
    job: string | null;
    mail_news_receive: boolean;
    listing_status?: BuyerListingStatus;
    waiting_request_meeting?: IMatch[] | [];
    account_profile_stage?: ProfileStage;
    phone_number?: string | null;
    invitation_code?: IInvitationCode | null;
}

export interface IBuyerUserForList {
    id: number;
    email: string;
    last_name: string;
    first_name: string;
    role: number;
    department: string | null;
    job: string | null;
    icon_image: string | null;
    phone_number: string | null;
}

export const buyerUserSchema = yup.object({
    id: yup.number().required(),
    last_name: yup.string().required(),
    first_name: yup.string().required(),
    last_name_kana: yup.string().nullable(),
    first_name_kana: yup.string().nullable(),
    email: yup.string().required(),
    birthday: yup.string().nullable(),
    gender: yup.number().required(),
    icon_image: yup.string().nullable().defined(),
    status: yup.number().required(),
    role: yup.number().oneOf(Object.values(BUYER_USER_ROLE)).required(),
    department: yup.string().nullable().defined(),
    job: yup.string().nullable().defined(),
    mail_news_receive: yup.boolean(),
    phone_number: yup.string().nullable().defined(),
});

export const isNotRegistrationComplete = (buyerUser: IBuyerUser | null): boolean => {
    if (!buyerUser) {
        return false;
    }
    return (
        buyerUser.account_profile_stage === PROFILE_STAGE.ONLY_PASSWORD ||
        buyerUser.account_profile_stage === PROFILE_STAGE.NEED_COMPANY_INFO
    );
};
